(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mist-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mist-header')) return;

    /* Let the cart count follow add-to-cart / cart edits made by the theme */
    if (!window.__mistHeaderFetch && typeof window.fetch === 'function') {
      window.__mistHeaderFetch = true;
      const nativeFetch = window.fetch;
      window.fetch = function (...args) {
        const request = nativeFetch.apply(this, args);
        try {
          const target = args[0];
          const url = typeof target === 'string' ? target : (target && target.url) || String(target);
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            request.then(() => document.dispatchEvent(new CustomEvent('mist-header:cart'))).catch(() => {});
          }
        } catch (e) {
          /* never interfere with the theme's request */
        }
        return request;
      };
    }

    const CART_EVENTS = ['mist-header:cart', 'cart:update', 'cart:updated', 'cart:refresh', 'cart:change'];

    class MistHeader extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.shopify-section') || this.parentElement;
        this.toggles = Array.from(this.querySelectorAll('details[data-mh-toggle]'));
        this.drawer = this.querySelector('.mh__drawer');
        this.desktop = window.matchMedia('(min-width: 990px)');

        this.update = this.update.bind(this);
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(this.update);
        };
        this.onKey = (event) => {
          if (event.key === 'Escape') this.closeAll();
        };
        this.onDocClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.onCart = () => this.refreshCart();
        this.onShow = (event) => {
          if (event.persisted) this.refreshCart();
        };
        this.onBreakpoint = () => {
          if (this.desktop.matches && this.drawer) this.drawer.open = false;
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        window.addEventListener('pageshow', this.onShow);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onDocClick);
        CART_EVENTS.forEach((name) => document.addEventListener(name, this.onCart));
        if (this.desktop.addEventListener) this.desktop.addEventListener('change', this.onBreakpoint);

        this.toggles.forEach((details) => {
          details.addEventListener('toggle', () => {
            if (details.open) {
              this.toggles.forEach((other) => {
                if (other !== details) other.open = false;
              });
              const input = details.querySelector('input[type="search"]');
              if (input) setTimeout(() => input.focus(), 60);
            }
            this.syncOpen();
          });
        });

        this.querySelectorAll('[data-mh-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeAll());
        });

        this.querySelectorAll('.mh__currency-select').forEach((select) => {
          select.addEventListener('change', () => {
            if (select.form) select.form.submit();
          });
        });

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        window.removeEventListener('pageshow', this.onShow);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDocClick);
        CART_EVENTS.forEach((name) => document.removeEventListener(name, this.onCart));
        if (this.desktop && this.desktop.removeEventListener) {
          this.desktop.removeEventListener('change', this.onBreakpoint);
        }
        document.documentElement.classList.remove('mh-lock');
      }

      update() {
        this.ticking = false;
        this.classList.toggle('is-scrolled', window.scrollY > 8);
        if (this.classList.contains('mh--sticky') && this.wrapper) {
          const top = Math.max(0, Math.round(this.wrapper.getBoundingClientRect().top));
          this.style.setProperty('--mh-top', `${top}px`);
        }
      }

      syncOpen() {
        this.classList.toggle('is-open', this.toggles.some((details) => details.open));
        document.documentElement.classList.toggle('mh-lock', Boolean(this.drawer && this.drawer.open));
      }

      closeAll() {
        this.toggles.forEach((details) => {
          details.open = false;
        });
      }

      async refreshCart() {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.querySelectorAll('[data-mh-count]').forEach((badge) => {
            badge.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
            badge.hidden = !cart.item_count;
          });
        } catch (e) {
          /* keep the last known count */
        }
      }
    }

    customElements.define('mist-header', MistHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mist-portrait-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mist-hero')) return;

    const rand = (a, b) => a + Math.random() * (b - a);

    const seeded = (seed) => () => {
      seed = (seed + 0x6d2b79f5) | 0;
      let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };

    const toRGB = (value) => {
      const v = String(value || '').trim();
      let m = v.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
      if (m) {
        let h = m[1];
        if (h.length === 3) h = h.split('').map((c) => c + c).join('');
        const n = parseInt(h, 16);
        return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
      }
      m = v.match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/);
      return m ? [m[1], m[2], m[3]].map((x) => Math.round(+x)) : [255, 138, 61];
    };

    /* Tileable fractal value noise, rendered small and scaled up by CSS,
       which gives soft, cheap fog. Computed once per page. */
    const fogCache = new Map();
    const fogTexture = (key, { seed, cells, octaves = 5, lo, hi, rgb, maxAlpha }) => {
      if (fogCache.has(key)) return fogCache.get(key);
      const w = 320;
      const h = 200;
      const rnd = seeded(seed);
      const layers = [];
      for (let o = 0; o < octaves; o++) {
        const cx = cells[0] << o;
        const cy = cells[1] << o;
        const grid = new Float32Array(cx * cy);
        for (let i = 0; i < grid.length; i++) grid[i] = rnd();
        layers.push({ cx, cy, grid, amp: 0.5 ** o });
      }
      const field = new Float32Array(w * h);
      let min = Infinity;
      let max = -Infinity;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          let v = 0;
          for (const L of layers) {
            const fx = (x / w) * L.cx;
            const fy = (y / h) * L.cy;
            const x0 = Math.floor(fx);
            const y0 = Math.floor(fy);
            const tx = fx - x0;
            const ty = fy - y0;
            const sx = tx * tx * (3 - 2 * tx);
            const sy = ty * ty * (3 - 2 * ty);
            const x1 = (x0 + 1) % L.cx;
            const y1 = (y0 + 1) % L.cy;
            const a = L.grid[y0 * L.cx + x0];
            const b = L.grid[y0 * L.cx + x1];
            const c = L.grid[y1 * L.cx + x0];
            const d = L.grid[y1 * L.cx + x1];
            v += L.amp * (a + (b - a) * sx + (c - a) * sy + (a - b - c + d) * sx * sy);
          }
          field[y * w + x] = v;
          if (v < min) min = v;
          if (v > max) max = v;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) return '';
      const img = ctx.createImageData(w, h);
      const range = max - min || 1;
      for (let i = 0; i < field.length; i++) {
        let a = ((field[i] - min) / range - lo) / (hi - lo);
        a = a < 0 ? 0 : a > 1 ? 1 : a;
        a = a * a * (3 - 2 * a);
        img.data[i * 4] = rgb[0];
        img.data[i * 4 + 1] = rgb[1];
        img.data[i * 4 + 2] = rgb[2];
        img.data[i * 4 + 3] = Math.round(a * maxAlpha * 255);
      }
      ctx.putImageData(img, 0, 0);
      const url = `url(${canvas.toDataURL('image/png')})`;
      fogCache.set(key, url);
      return url;
    };

    class MistHero extends HTMLElement {
      connectedCallback() {
        this.style.setProperty(
          '--mh-fog-mist',
          fogTexture('mist', { seed: 7, cells: [4, 3], lo: 0.46, hi: 0.82, rgb: [255, 255, 255], maxAlpha: 0.92 })
        );
        this.style.setProperty(
          '--mh-fog-smoke',
          fogTexture('smoke', { seed: 23, cells: [3, 2], lo: 0.5, hi: 0.92, rgb: [104, 98, 110], maxAlpha: 0.5 })
        );

        this.canvas = this.querySelector('.mist-hero__particles');
        this.ctx = this.canvas && this.canvas.getContext('2d');
        if (!this.ctx) return;

        this.still =
          !this.classList.contains('mist-hero--animated') ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.makeSprites(toRGB(this.dataset.accent));
        this.frame = this.frame.bind(this);
        this.sync = this.sync.bind(this);

        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this);
        this.viewObserver = new IntersectionObserver((entries) => {
          this.inView = entries[entries.length - 1].isIntersecting;
          this.sync();
        });
        this.viewObserver.observe(this);
        document.addEventListener('visibilitychange', this.sync);
        requestAnimationFrame(() => this.classList.add('is-ready'));
      }

      disconnectedCallback() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.sync) document.removeEventListener('visibilitychange', this.sync);
      }

      makeSprites([r, g, b]) {
        const orb = (rgb, peak) => {
          const c = document.createElement('canvas');
          c.width = c.height = 128;
          const x = c.getContext('2d');
          const grad = x.createRadialGradient(64, 64, 0, 64, 64, 64);
          grad.addColorStop(0, `rgba(${rgb},${peak})`);
          grad.addColorStop(0.5, `rgba(${rgb},${peak * 0.8})`);
          grad.addColorStop(0.78, `rgba(${rgb},${peak * 0.38})`);
          grad.addColorStop(1, `rgba(${rgb},0)`);
          x.fillStyle = grad;
          x.fillRect(0, 0, 128, 128);
          return c;
        };
        this.whiteOrb = orb('255,255,255', 1);
        this.warmOrb = orb(`${r},${g},${b}`, 0.95);

        const s = document.createElement('canvas');
        s.width = 256;
        s.height = 32;
        const x = s.getContext('2d');
        const along = x.createLinearGradient(0, 0, 256, 0);
        along.addColorStop(0, `rgba(${r},${g},${b},0)`);
        along.addColorStop(0.3, `rgba(${r},${g},${b},0.7)`);
        along.addColorStop(0.5, 'rgba(255,244,226,1)');
        along.addColorStop(0.7, `rgba(${r},${g},${b},0.7)`);
        along.addColorStop(1, `rgba(${r},${g},${b},0)`);
        x.fillStyle = along;
        x.fillRect(0, 0, 256, 32);
        x.globalCompositeOperation = 'destination-in';
        const across = x.createLinearGradient(0, 0, 0, 32);
        across.addColorStop(0, 'rgba(0,0,0,0)');
        across.addColorStop(0.5, 'rgba(0,0,0,1)');
        across.addColorStop(1, 'rgba(0,0,0,0)');
        x.fillStyle = across;
        x.fillRect(0, 0, 256, 32);
        this.streakSprite = s;
      }

      resize() {
        const w = this.clientWidth;
        const h = this.clientHeight;
        if (!w || !h) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(w * dpr);
        this.canvas.height = Math.round(h * dpr);
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const reseed = !this.orbs || Math.abs(w - this.w) > 60 || Math.abs(h - this.h) > 160;
        this.w = w;
        this.h = h;
        this.unit = Math.min(1.5, Math.max(0.65, w / 1440));
        if (reseed) this.seed();
        this.draw(0, performance.now() / 1000);
        this.sync();
      }

      seed() {
        const k = this.w < 750 ? 0.55 : 1;
        const orbs = Math.round((parseInt(this.dataset.bokeh, 10) || 0) * k);
        const streaks = Math.round((parseInt(this.dataset.embers, 10) || 0) * k);
        this.orbs = Array.from({ length: orbs }, () => this.newOrb(true));
        this.specks = Array.from({ length: Math.round(orbs * 2.4) }, () => this.newSpeck(true));
        this.streaks = Array.from({ length: streaks }, () => this.newStreak(true));
      }

      newOrb(anywhere) {
        const u = this.unit;
        const p = Math.random();
        const r = (p < 0.6 ? rand(2.5, 7) : p < 0.9 ? rand(8, 15) : rand(17, 30)) * u;
        return {
          x: rand(-30, this.w + 30),
          y: anywhere ? rand(-30, this.h + 30) : this.h + r + rand(0, 80),
          r,
          a: r > 16 * u ? rand(0.14, 0.3) : rand(0.3, 0.75),
          warm: Math.random() < 0.05,
          vx: rand(-4, 4),
          vy: -rand(5, 16),
          ph: rand(0, 6.28),
          sp: rand(0.35, 1.1),
        };
      }

      newSpeck(anywhere) {
        const u = this.unit;
        return {
          x: rand(0, this.w),
          y: anywhere ? rand(0, this.h) : this.h + 10,
          r: rand(0.6, 1.8) * u,
          a: rand(0.35, 0.95),
          warm: Math.random() < 0.15,
          vx: rand(-5, 5),
          vy: -rand(3, 12),
          ph: rand(0, 6.28),
          sp: rand(1, 3.2),
        };
      }

      newStreak(anywhere) {
        const u = this.unit;
        const vx = rand(6, 18);
        const vy = rand(3, 11);
        return {
          x: anywhere ? rand(0, this.w) : rand(-this.w * 0.2, this.w * 0.8),
          y: anywhere ? rand(0, this.h) : -40,
          len: rand(40, 130) * u,
          th: rand(2.5, 6) * u,
          ang: Math.atan2(vy, vx) + rand(-0.12, 0.12),
          a: rand(0.4, 0.9),
          vx,
          vy,
          ph: rand(0, 6.28),
          sp: rand(0.4, 1.1),
        };
      }

      sync() {
        const run = this.inView && !document.hidden && !this.still && this.w;
        if (run && !this.raf) {
          this.last = performance.now();
          this.raf = requestAnimationFrame(this.frame);
        } else if (!run && this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }

      frame(now) {
        const dt = Math.min((now - this.last) / 1000, 0.05);
        this.last = now;
        this.draw(dt, now / 1000);
        this.raf = requestAnimationFrame(this.frame);
      }

      draw(dt, t) {
        const g = this.ctx;
        const W = this.w;
        const H = this.h;
        g.clearRect(0, 0, W, H);

        for (let i = 0; i < this.orbs.length; i++) {
          const o = this.orbs[i];
          if (dt) {
            o.x += (o.vx + Math.sin(t * 0.25 + o.ph) * 4) * dt;
            o.y += o.vy * dt;
            if (o.y < -o.r * 2 || o.x < -60 || o.x > W + 60) this.orbs[i] = this.newOrb(false);
          }
          g.globalAlpha = o.a * (0.72 + 0.28 * Math.sin(t * o.sp + o.ph));
          g.drawImage(o.warm ? this.warmOrb : this.whiteOrb, o.x - o.r, o.y - o.r, o.r * 2, o.r * 2);
        }

        for (let i = 0; i < this.specks.length; i++) {
          const p = this.specks[i];
          if (dt) {
            p.x += (p.vx + Math.sin(t * 0.6 + p.ph) * 3) * dt;
            p.y += p.vy * dt;
            if (p.y < -10 || p.x < -20 || p.x > W + 20) this.specks[i] = this.newSpeck(false);
          }
          g.globalAlpha = p.a * (0.5 + 0.5 * Math.sin(t * p.sp + p.ph));
          const d = p.r * 3;
          g.drawImage(p.warm ? this.warmOrb : this.whiteOrb, p.x - d / 2, p.y - d / 2, d, d);
        }

        for (let i = 0; i < this.streaks.length; i++) {
          const s = this.streaks[i];
          if (dt) {
            s.x += s.vx * dt;
            s.y += s.vy * dt;
            if (s.x > W + s.len || s.y > H + s.len) this.streaks[i] = this.newStreak(false);
          }
          const alpha = s.a * Math.max(0, 0.25 + 0.75 * Math.sin(t * s.sp + s.ph));
          if (alpha < 0.01) continue;
          const halo = s.len * 0.7;
          g.globalAlpha = alpha * 0.22;
          g.drawImage(this.warmOrb, s.x - halo / 2, s.y - halo / 2, halo, halo);
          g.globalAlpha = alpha;
          g.save();
          g.translate(s.x, s.y);
          g.rotate(s.ang);
          g.drawImage(this.streakSprite, -s.len / 2, -s.th / 2, s.len, s.th);
          g.restore();
        }

        g.globalAlpha = 1;
      }
    }

    customElements.define('mist-hero', MistHero);
  })();

  } catch(e) { console.error(e); }
})();
})();
